module.exports = __webpack_public_path__ + "static/media/serv_log.71c54b92.png";